/**
 * NOT USED
 */
export class VetineoLicenceStatus {
  public vetineo: string[];
  public sitesbi: string[];
  public kxp: string[];


  noErrorsOccured() {
    return this.vetineo.length ===  0 && this.sitesbi.length ===  0 && this.kxp.length ===  0;
  }
}

